import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    // Get scan_id from localStorage if available (set during onboarding)
    const scanId = localStorage.getItem('gcf_scan_id');

    const exchange = async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, {
          session_id: sessionId,
          scan_id: scanId,
        }, { withCredentials: true });

        login(res.data.user);
        localStorage.removeItem('gcf_scan_id');

        // Clear hash and navigate to dashboard
        navigate('/dashboard', { replace: true, state: { user: res.data.user } });
      } catch (err) {
        // Auth exchange failed
        navigate('/', { replace: true });
      }
    };

    exchange();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="text-center">
        <div className="w-8 h-8 border-2 rounded-full animate-spin mx-auto mb-4" style={{ borderColor: '#D4C9B8', borderTopColor: 'transparent' }} />
        <p style={{ color: '#777' }}>Signing you in...</p>
      </div>
    </div>
  );
}
